export function referrerFromProductPage(previousUrl: string) {
	return /\/p\//.test(previousUrl)
}
